<router-outlet />

@if (message()) {
  <div class="message message-{{ message().type }}">
    <h4>{{ message().title }}</h4>
    @if (message().text) {
      <span>{{ message().text }}</span>
    }
  </div>
}
